import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
import ConsultantAlertAndHeadCard from '../../../Ui/Card/ConsultantAlertAndHeadCard';
import ExaminationAlertAndHeadCardFullModal from '../../../Ui/Modal/ExaminationAlertAndHeadCardFullModal';
const ConsultantSearchAlertCardList = (props) => {
    const { isPre, isProfessional, isShowPreAlert, onClickExaminationAlert, search, } = props;
    if (isProfessional) {
        return (_jsxs("div", Object.assign({ className: 'alert-card-wrapper' }, { children: [_jsx("div", { className: 'alert-card-bg' }), _jsx(ConsultantAlertAndHeadCard, {})] })));
    }
    if (isPre && search !== 'seminar') {
        return (_jsx(ExaminationAlertAndHeadCardFullModal, { isShow: isShowPreAlert, onClickClose: onClickExaminationAlert }));
    }
    return null;
};
ConsultantSearchAlertCardList.propTypes = {
    isPre: propBool().isRequired,
    isProfessional: propBool().isRequired,
    isShowPreAlert: propBool().isRequired,
    onClickExaminationAlert: propFunc().isRequired,
    search: propStr().isRequired,
};
export default ConsultantSearchAlertCardList;
